/**
 * Analytics wrapper — GA4 (gtag) + Meta Pixel + GTM dataLayer.
 * All calls are safe no-ops when the underlying tag hasn't been loaded
 * (i.e. env vars are unset).
 *
 * Usage: import { trackEvent } from '@/utils/analytics';
 *        trackEvent('quote_request_submitted', { source: 'hero' });
 */

const isBrowser = typeof window !== 'undefined';

export const trackEvent = (name, params = {}) => {
  if (!isBrowser) return;
  try {
    // GA4
    if (window.gtag) window.gtag('event', name, params);
    // GTM dataLayer
    if (window.dataLayer) window.dataLayer.push({ event: name, ...params });
    // Meta Pixel — auto-map a few standard events
    if (window.fbq) {
      const stdMap = {
        quote_request_submitted: 'Lead',
        whatsapp_click: 'Contact',
        request_quote_open: 'InitiateCheckout',
        blog_read_75pct: 'ViewContent',
      };
      const std = stdMap[name];
      if (std) window.fbq('track', std, params);
      else window.fbq('trackCustom', name, params);
    }
  } catch (e) {
    // best-effort, never break the page
  }
};

export const trackPageView = (path) => {
  if (!isBrowser) return;
  const p = path || window.location.pathname + window.location.search;
  try {
    if (window.gtag && window.GA4_ID) {
      window.gtag('config', window.GA4_ID, { page_path: p });
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'page_view', page_path: p });
    if (window.fbq) window.fbq('track', 'PageView');
  } catch (e) {}
};
